import { FC } from 'react'

import { Props } from './props'
import { Wrapper } from './styles'

export const Skeleton: FC<Props> = props => <Wrapper {...props}>&zwnj;</Wrapper>
